/* Include */
function consoleMessage(messageText, messageType, outputDisabled) {
    if (outputDisabled) {
        return false;
    }

    if (messageType) {
        consoleLog(messageType);
    }

    consoleLog(messageText);
}

function delay(callback, ms) {
    var timer = 0;
    return function() {
        var context = this, args = arguments;
        clearTimeout(timer);
        timer = setTimeout(function () {
            callback.apply(context, args);
        }, ms || 0);
    };
}

var delayed = (function(){
    var timer = 0;
    return function(callback, ms){
        clearTimeout(timer);
        timer = setTimeout(callback, ms);
    };
})();

function makeDelay(ms) {
    var timer = 0;
    return function(callback){
        clearTimeout (timer);
        timer = setTimeout(callback, ms);
    };
};

function removeSpecifiedValue(array, value) {
    for(var i = array.length - 1; i >= 0; i--) {
        if(array[i] === value) {
            array.splice(i, 1);
            consoleLog(value + ' remove from array');
            consoleLog(array);
        }
    }
}

//How to serialize form data with vanilla JS
var serialize = function (form) {

    // Setup our serialized data
    var serialized = [];

    // Loop through each field in the form
    for (var i = 0; i < form.elements.length; i++) {

        var field = form.elements[i];

        // Don't serialize fields without a name, submits, buttons, file and reset inputs, and disabled fields
        if (!field.name || field.disabled || field.type === 'file' || field.type === 'reset' || field.type === 'submit' || field.type === 'button') continue;

        // If a multi-select, get all selections
        if (field.type === 'select-multiple') {
            for (var n = 0; n < field.options.length; n++) {
                if (!field.options[n].selected) continue;
                serialized.push(encodeURIComponent(field.name) + "=" + encodeURIComponent(field.options[n].value));
            }
        }

        // Convert field data to a query string
        else if ((field.type !== 'checkbox' && field.type !== 'radio') || field.checked) {
            serialized.push(encodeURIComponent(field.name) + "=" + encodeURIComponent(field.value));
        }
    }

    return serialized.join('&');

};

// Bootstrap Notify
function successNotification(message) {
    if (typeof message == 'object') {
        message = 'Message / Obj / Improve';
    }
    $.notify({
        message: message
    },{
        type: 'success',
        allow_dismiss: false,
        delay: 300,
        animate: {
            enter: 'animated fadeInDown',
            exit: 'animated fadeOutUp'
        },
        onShow: function() {
            //this.css({'width':'auto','height':'auto'});
        },
        //showProgressbar: true,
        placement: {
            from: "top",
            align: "center"
        },
        z_index: 1051
    });
}

function warningNotification(message) {
    if (typeof message == 'object') {
        message = 'Message / Obj / Improve';
    }
    $.notify({
        message: message
    },{
        type: 'warning',
        allow_dismiss: false,
        delay: 3000,
        animate: {
            enter: 'animated fadeInDown',
            exit: 'animated fadeOutUp'
        },
        placement: {
            from: "top",
            align: "center"
        },
        z_index: 1051
    });
}
function dangerNotification(message) {
    if (typeof message == 'object') {
        message = 'Message / Obj / Improve';
    }
    $.notify({
        message: message
    },{
        type: 'danger',
        allow_dismiss: false,
        delay: 5000,
        animate: {
            enter: 'animated fadeInDown',
            exit: 'animated fadeOutUp'
        },
        placement: {
            from: "top",
            align: "center"
        },
        z_index: 1051
    });
}

// For URL
function insertUrlParam(key, value)
{
    key = encodeURI(key); value = encodeURI(value);

    var kvp = document.location.search.substr(1).split('&');

    var i=kvp.length; var x; while(i--)
{
    x = kvp[i].split('=');

    if (x[0]==key)
    {
        x[1] = value;
        kvp[i] = x.join('=');
        break;
    }
}

    if(i<0) {kvp[kvp.length] = [key,value].join('=');}

    //this will reload the page, it's likely better to store this until finished
    document.location.search = kvp.join('&');
}

function copy(element) {
    var temp = $('<input>');
    $('body').append(temp);
    temp.val($(element).text()).select();
    document.execCommand('copy');
    temp.remove();
}

var consoleLogEnabled = true;
function consoleLog(obj) {
    if (consoleLogEnabled) {
        console.log(obj);
    }
}

var isItScrollableWithoutVisibleScrollbars = function(el) {
    if (el === null) {
        return false;
    }
    var isScrollable = false;
    var hasScrollbars = false;
    // first, lets find out if it has scrollable content
    isScrollable = el.scrollHeight > el.offsetHeight ? true : false;
    // if it's scrollable, let's see if it likely has scrollbars
    if (isScrollable) {
        hasScrollbars = (el.offsetWidth > el.scrollWidth) ? true : false;
    }
    if (isScrollable && !hasScrollbars) {
        return true;
    } else {
        return false;
    }
};


var isItScrollable = function(el) {
    if (el === null) {
        return false;
    }
    var isScrollable = false;
    // first, lets find out if it has scrollable content
    isScrollable = el.scrollHeight > el.offsetHeight ? true : false;
    // if it's scrollable, let's see if it likely has scrollbars
    if (isScrollable) {
        return true;
    } else {
        return false;
    }
};

Array.prototype.first = function () {
    return this[0];
};

function makeid(length) {
    var result           = '';
    var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for ( var i = 0; i < length; i++ ) {
        result += characters.charAt(Math.floor(Math.random() *
            charactersLength));
    }
    return result;
}
$.fn.typePause = function (dataObject, eventFunc)
{
    if(typeof dataObject === 'function')
    {
        eventFunc = dataObject;
        dataObject = {};
    }
    if(typeof dataObject.milliseconds === 'undefined')
        dataObject.milliseconds = 500;
    $(this).data('timeout', null)
        .keypress(dataObject, function(e)
        {
            clearTimeout($(this).data('timeout'));
            $(this).data('timeout', setTimeout($.proxy(eventFunc, this, e), dataObject.milliseconds));
        })
        .keyup(dataObject, function(e)
        {
            var code = (e.keyCode ? e.keyCode : e.which);
            if(code == 8 || code == 127 || code == 13 || code == 9)
                $(this).triggerHandler('keypress',dataObject);
        });
};

$.fn.serializeObject = function()
{
    consoleLog('Serialize Form (jQ Extra)');
    var o = {};
    var a = this.serializeArray();
    $.each(a, function() {
        if (o[this.name]) {
            if (!o[this.name].push) {
                o[this.name] = [o[this.name]];
            }
            o[this.name].push(this.value || '');
        } else {
            o[this.name] = this.value || '';
        }
    });
    return o;
};

// Button loading, complete and default
// Element:
// button/a <a><i.fa.fa-icon></i><span>Text<span></a>
// Add optional attributes to button element:
// 'loading-text'
// 'complete-text'
// 'loading-icon'
// 'complete-icon'
$.fn.binteract = function (action) {
    var button = this;

    // Append or prepend icon
    var append_icon = true;
    this.find('span, svg').each(function (i) {
        consoleLog(i);
        consoleLog($(this));
        if (i == 0 && $(this).is('svg')) {
            append_icon = false;
        }
        consoleLog('Each->');
        consoleLog(append_icon);
    });
    consoleLog(append_icon);

    if (action === 'loading') {
        button.prop('disabled', true);
        button.addClass('disabled');
        var original_text = button.find('span').html();
        var icon = button.find('svg')
        var icon_class = icon.attr('class');
        var original_icon = icon.data('prefix') + ' fa-' + icon.data('icon');
        this.data('original-text', original_text)
        this.data('original-icon', original_icon)
        var text = button.data('loading-text') ? button.data('loading-text') : 'Loading...';
        var icon = button.data('loading-icon') ? ' <i class="' + button.data('loading-icon')  + '"></i>' : ' <i class="fas fa-spinner fa-pulse"></i>';
    }
    if (action === 'complete') {
        var text = button.data('complete-text') ? button.data('complete-text') : 'Complete';
        var icon = button.data('complete-icon') ? ' <i class="' + button.data('complete-icon')  + '"></i>' : ' <i class="fas fa-check"></i>';
    }
    if (action === 'reset') {
        var text = button.data('original-text') ? button.data('original-text') : 'Try again';
        var icon = button.data('original-icon') ? ' <i class="' + button.data('original-icon')  + '"></i>' : ' <i class="fas fa-long-arrow-alt-right"></i>';
        button.removeClass('disabled');
        button.prop('disabled', false);
    }

    // Text
    button.find('span').html(text);
    // Icon
    button.find('i').remove()
    button.find('svg').remove()
    if (append_icon) {
        button.append(icon);
    } else {
        button.prepend(icon);
    }
}

$.fn.overlayloader = function (action) {
    $('body').append('<div class="overlay-loader__container"></div>');
    var element = $('.overlay-loader__container');

    if (!element.hasClass('overlay-loader')) {
        element.addClass('overlay-loader');
    }

    if (action === 'on') {
        element.addClass('overlay-loader__on');
        element.after('<i class="overlay-loader__icon fas fa-spinner fa-pulse"></i>')
    }
    if (action === 'off') {
        element.removeClass('overlay-loader__on');
        $('.overlay-loader__icon').remove()
        $('.overlay-loader__container').remove();
    }
}

// Bootstrap tooltips
$(function () {
    $('[data-bs-toggle="tooltip"]').each(function () {
        new bootstrap.Tooltip(this);
    });
});


// Filter
$(document).on('input', '.js-countrySearch', function () {
    var that = $(this);
    $('.search-results').remove();
    that.overlayloader('off')
    var val = that.val().toLowerCase();

    if (val.length < 2) {
        return false;
    }

    delayed(function () {
        that.overlayloader('on')
        if (val.length < 2) {
            $('.search-results').remove();
        }
        axios.get('/country/search/' + val).then(function (response) {
            consoleLog('Response: ');
            consoleLog(response);
            if (response.status == 200) {
                consoleLog(response);
                that.parent().after(response.data);
            } else if (response.status == 202 || response.status == 206) {
                consoleLog(response);
            } else {
                consoleLog('Unknown Error');
                dangerNotification('Unknown Error');
            }
            that.overlayloader('off')
        }).catch(function (error) {
            consoleLog(error);
            dangerNotification('Error');
            that.overlayloader('off')
        });
    }, 500);
});


// Contact Us

$(document).on('click', '.js-contactUs', function () {
    var that = $(this);
    var route = '/contacts/create';
    var modal = $('#contact-modal');
    var modalTitle = $('#contact-modal .modal-title');
    var modalBody = $('#contact-modal .modal-body');

    var ids = that[0].dataset;
    consoleLog(ids);

    // Get pop/modal data (form HTML)
    axios.post(route, { data: ids }).then(function (response) { // !!!
        consoleLog('Response: ');
        consoleLog(response);
        if (response.status == 200) {
            modalTitle.html(response.data.title);
            modalBody.html(response.data.body);
            modal.modal('show');
        } else if (response.status == 202 || response.status == 206) {
            modalBody.html('<span class="text-danger">' + response.data + '</span>');
            modal.modal('show');
        } else {
            consoleLog('Unknown Error');
            dangerNotification('Unknown Error');
        }
    }).catch(function (error) {
        consoleLog(error);
        dangerNotification('Error');
    });
});


$(document).on('click', '.js-sendContactUs', function () {
    var that = $(this);
    var route = $(this).data('route');
    var form = $('form.contact');
    var formdata = form.serializeObject();
    var modal = $('#contact-modal');

    that.binteract('loading');


    $('form.contact :input:visible[required="required"]').each(function() {
        if(!this.validity.valid) {
            $(this).focus();
            if ($(this).val().length) {
                warningNotification('Проверьте значение');
            } else {
                warningNotification('Обязательное поле');
            }
            that.binteract('reset');

            return false;
        }
    });

    axios.post(route, {form: formdata})
        .then(function (response) {
            consoleLog('Response: ');
            consoleLog(response);
            if (response.status == 200) {
                if (response.data.success) {
                    that.binteract('complete');
                    modal.find('.modal-body').html(
                        '<p class="m-0"><i class="fas fa-check-circle text-success me-1"></i> '
                        + response.data.message + '</p>'
                    );
                } else {
                    dangerNotification(response.data.message)
                    that.binteract('reset');
                }
            } else {
                consoleLog('Unknown Error');
                that.binteract('reset');
                dangerNotification('Unknown Error');
            }
        }).catch(function (error) {
        consoleLog(error);
        that.binteract('reset');
        dangerNotification('Error');
    });
});

// Checklist lead magnet
$(document).on('click', '.js-sendChecklist', function () {
    var that = $(this);
    var route = $(this).data('route');
    var modal = $('#checklist-modal');
    var input = modal.find('input[name="email"]')[0];

    if (!input.validity.valid) {
        $(input).focus();
        if (input.value.length) {
            warningNotification('Проверьте значение');
        } else {
            warningNotification('Обязательное поле');
        }
        return false;
    }

    that.binteract('loading');

    axios.post(route, {
        email: input.value,
        newsletter: modal.find('input[name="newsletter"]').prop('checked') ? 1 : 0
    })
        .then(function (response) {
            consoleLog('Response: ');
            consoleLog(response);
            if (response.status == 200 && response.data.success) {
                that.binteract('complete');
                successNotification(response.data.message);

                if (response.data.url) {
                    var link = document.createElement('a');
                    link.href = response.data.url;
                    link.download = '';
                    document.body.appendChild(link);
                    link.click();
                    link.remove();

                    setTimeout(function () {
                        modal.modal('hide');
                        that.binteract('reset');
                    }, 2000);
                } else {
                    modal.find('.modal-body').html('<p class="m-0">' + response.data.message + '</p>');
                }
            } else {
                dangerNotification(response.data.message || 'Error');
                that.binteract('reset');
            }
        }).catch(function (error) {
        consoleLog(error);
        that.binteract('reset');
        dangerNotification('Error');
    });
});

// Audio versions
$(document).on('click', '.js-audioToggle', function () {
    var wrap = $(this).closest('.gc-audio');
    $(this).addClass('d-none');
    var player = wrap.find('audio');
    player.removeClass('d-none');
    player[0].play();
});

// Add link to the copied information
function addLink(event) {

    var host = window.location.hostname;
    var noSourceLink = host.indexOf('stage.') === 0 || host === 'localhost' || host.indexOf('.local') > -1;

    if(noSourceLink || window.location.href.indexOf("administrative") > -1) {
        return true;
    } else {
        event.preventDefault();

        var locale = $('html').attr('lang');
        var source_localed = '\n Источник материала: ';
        if (locale == 'en') {
            source_localed = '\n Material source: ';
        }
        if (locale == 'de') {
            source_localed = '\n Quelle des Materials: ';
        }
        var pagelink = source_localed + document.location.href,
            copytext =  window.getSelection() + pagelink;

        (event.clipboardData || window.clipboardData).setData('Text', copytext);
    }

}
document.addEventListener('copy', addLink);